export enum OrderCategory {
  BIG_ORDER = 'BIGO',
  FOREIGN_JOBSITES = 'FORE',
  COMMENTS = 'COMS',
}
